import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import classNames from "classnames";
import * as React from "react";
import { NavLink } from "..";
import NavItem from "./NavItem";
import "./scss/index.scss";

var NavDropdown =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NavDropdown, _React$PureComponent);

  function NavDropdown() {
    _classCallCheck(this, NavDropdown);

    return _possibleConstructorReturn(this, _getPrototypeOf(NavDropdown).apply(this, arguments));
  }

  _createClass(NavDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          showDropdown = _this$props.showDropdown,
          onShowDropdown = _this$props.onShowDropdown,
          onHideDropdown = _this$props.onHideDropdown;
      return React.createElement("ul", {
        className: classNames({
          "main-menu__nav-dropdown": true,
          "main-menu__nav-dropdown--active": showDropdown
        }),
        onMouseOver: onShowDropdown,
        onMouseLeave: onHideDropdown
      }, React.createElement("li", null, React.createElement(NavLink, {
        item: this.props,
        onClick: onHideDropdown
      })), React.createElement("li", {
        className: classNames({
          "main-menu__nav-dropdown__body": true,
          "main-menu__nav-dropdown__body--visible": showDropdown
        })
      }, React.createElement("ul", null, children.map(function (subItem, i) {
        return React.createElement(NavItem, _extends({
          key: i,
          hideOverlay: onHideDropdown
        }, subItem));
      }))));
    }
  }]);

  return NavDropdown;
}(React.PureComponent);

export default NavDropdown;